import { api } from '@/services/api/AxiosBaseService'
import { createCrudService } from '@/services/api/createCrudService'
import type { SingleResponse } from '@/types/api'

export type ReportTemplateFormat = 'xlsx' | 'csv'
export type ColumnSourceType = 'FIELD' | 'CONSTANT' | 'BLANK'

export interface ReportTemplateColumn {
  id?: string
  position?: number
  label: string
  sourceType: ColumnSourceType
  sourceKey: string | null
  constantValue: string | null
  format: string | null
}

export interface ReportTemplateFamilyDegree {
  id?: string
  degreeRelationshipId: string
  degreeName?: string
  applyAgeLimit: boolean
}

export interface ReportTemplate {
  id: string
  /** Prestadores que compartilham esta estrutura (0..N). */
  serviceProviders?: Array<{ id: string; name: string }>
  serviceProviderIds?: string[]
  name: string
  format: ReportTemplateFormat
  /** null = estrutura personalizada (colunas); senão layout embutido (medicar/porto-seguro/auster). */
  builtinKey: string | null
  childAgeLimit: number
  status: 'ATIVO' | 'INATIVO'
  columns?: ReportTemplateColumn[]
  familyDegrees?: ReportTemplateFamilyDegree[]
  createdAt?: string
  updatedAt?: string
}

/** Payload de escrita (snake_case é convertido pelo middleware; enviamos camelCase). */
export interface ReportTemplatePayload {
  serviceProviderIds?: string[]
  name?: string
  format?: ReportTemplateFormat
  builtinKey?: string | null
  childAgeLimit?: number
  status?: 'ATIVO' | 'INATIVO'
  columns?: Array<{
    label: string
    sourceType: ColumnSourceType
    sourceKey?: string | null
    constantValue?: string | null
    format?: string | null
  }>
  familyDegrees?: Array<{ degreeRelationshipId: string; applyAgeLimit: boolean }>
}

export interface FieldCatalogItem { key: string; label: string }
export interface BuiltinOption { value: string; label: string }
export interface FieldCatalog { fields: FieldCatalogItem[]; formats: string[]; builtins: BuiltinOption[] }

const base = createCrudService<ReportTemplate, ReportTemplatePayload>(
  '/settings/report-templates',
  { searchField: 'name' },
)

export const ReportTemplatesService = {
  ...base,
  async fieldCatalog(): Promise<FieldCatalog> {
    const res = await api.get<SingleResponse<FieldCatalog>>('/settings/report-templates/field-catalog')
    return res.data.data
  },
}
